export const carouselType = {
    product: "מוצרים",
    banner: "באנרים",
    miniCategory: "מיני קטגוריות"
};
